var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useRef } from 'react';
import { Portal } from 'react-portal';
import { registerClass, cns, getContext, defaultTheme, currySC, } from '@food/css-manager';
import { LayoutHandler } from './LayoutHandler';
export var ModalLayouts;
(function (ModalLayouts) {
    ModalLayouts["Full"] = "Full";
    ModalLayouts["Compact"] = "Compact";
})(ModalLayouts || (ModalLayouts = {}));
var layoutChooser = function (width) {
    if (width > defaultTheme.breakpoints.mobileMax) {
        return ModalLayouts.Full;
    }
    else {
        return ModalLayouts.Compact;
    }
};
// il contatore di modal aperte all'interno di una stessa applicazione
var counter = 0;
var styleClass = registerClass(function (t, sc) { return "\n\toverflow-y: auto;\n\tmax-height: 100vh;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: " + (t.zIndexes.P4_Modal - 1) + ";\n\n\t." + sc('background') + " {\n\t\tbackground-color: rgba(0, 0, 0, " + t.dimmerOpacity + ");\n\t\tmin-height: 100vh;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: " + t.ratios.xl * 2 * t.font.baseSize + "px;\n\t\tjustify-content: center;\n\t\tanimation-name: fadeIn;\n\t\tanimation-duration: " + t.timings.base / 1000 + "s;\n\t\tanimation-fill-mode: both\n\t\t\n\t\t@keyframes fadeIn {\n\t\t\n\t\t\tfrom {\n\t\t\t\topacity: 0;\n\t\t\t}\n\t\t\t\n\t\t\tto {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n\n\t." + sc('body') + " {\n\t\twidth: 90%; // Lascia un minimo di bordo\n\t\tmax-width: 900px; // FIXME\n\t\tbackground-color: " + t.colors.white + ";\n\t\tbox-shadow: " + t.boxShadow(2) + ";\n\t\toverflow: visible;\n\t\tz-index: " + t.zIndexes.P4_Modal + ";\n\t\tposition: relative;\n\n\t\tp,\n\t\tul,\n\t\tol {\n\t\t\tmargin-bottom: " + (t.ratios.xl / 2) * t.font.baseSize + "px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t\n\t\tul,\n\t\tol {\n\t\t\tlist-style: disc;\n\t\t\tpadding-left: 1em;\n\n\t\t\tli {\n\t\t\t\tmargin-bottom: " + (t.ratios.s / 2) * t.font.baseSize + "px;\n\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tol {\n\t\t\tlist-style: decimal;\n\t\t}\n\t}\n\t\n\t&." + sc('layout', ModalLayouts.Compact) + " {\n\t\t\n\t\t." + sc('background') + " {\n\t\t\tpadding: " + t.font.baseSize + "px;\n\t\t}\n\t\t\n\t\t." + sc('body') + " {\n\t\t\twidth: 100%;\n\t\t\tmax-width: unset;\n\t\t}\n\t}\n"; }, false);
var sc = currySC(styleClass);
export var Modal = function (_a) {
    var open = _a.open, className = _a.className, children = _a.children, zIndex = _a.zIndex, style = _a.style, closeHandler = _a.closeHandler;
    var backgroundRef = useRef();
    useEffect(function () {
        if (open) {
            counter += 1;
            document.body.style.overflowY = 'hidden';
        }
        else {
            var oldCounter = counter;
            counter = Math.max(counter - 1, 0);
            if (oldCounter !== 0 && counter === 0) {
                // il contatore a 0 significa che nessuna modal e' aperta nell'applicazione, quindi devo riattivare lo scroll del body
                document.body.style.overflowY = 'auto';
            }
        }
    }, [open]);
    if (!open) {
        return null;
    }
    return (React.createElement(Portal, null,
        React.createElement(LayoutHandler, { layouts: { layout: layoutChooser } }, function (_a) {
            var _b;
            var layout = _a.layout;
            return (React.createElement("div", { className: cns.apply(void 0, __spreadArrays([styleClass,
                    className], (((_b = getContext()) === null || _b === void 0 ? void 0 : _b.portalClasses) || []), [sc('layout', layout)])), style: { zIndex: zIndex } },
                React.createElement("div", { className: sc('background'), ref: backgroundRef, onClick: function (evt) {
                        if (evt.target === backgroundRef.current &&
                            closeHandler) {
                            closeHandler();
                        }
                    } },
                    React.createElement("div", { className: sc('body'), style: style }, children({ layout: layout, counter: counter })))));
        })));
};
//# sourceMappingURL=Modal2.js.map